import {
  getSelectedPlanInfo,
  type GetSelectedPlanInfoInput,
} from './getSelectedPlanInfo';

export type ProtectionCardVariant =
  | 'pendingInvoice'
  | 'trialExpired'
  | 'trialActive'
  | 'upgradeCycle'
  | 'proPlan'
  | 'none';

export type ResolveProtectionCardVariantOptions = {
  isUpgradeCycleModalEnabled: boolean;
};

export const resolveProtectionCardVariant = (
  selectedPlan: GetSelectedPlanInfoInput | null | undefined,
  options: ResolveProtectionCardVariantOptions,
): ProtectionCardVariant => {
  const planInfo = getSelectedPlanInfo(selectedPlan);

  if ((planInfo.isTurbo && planInfo.isProActive) || planInfo.isTriennialHostingCycle) {
    return 'none';
  }

  if (planInfo.hasInvoice) {
    return 'pendingInvoice';
  }

  if (planInfo.isTrialExpired) {
    return 'trialExpired';
  }

  if (planInfo.isTrialActive) {
    return 'trialActive';
  }

  if (options.isUpgradeCycleModalEnabled && planInfo.isProUpgradeCycleUpsellEligible) {
    return 'upgradeCycle';
  }

  return 'proPlan';
};
